import React, { createContext, useCallback, useEffect, useState } from 'react'

export const ThemeContext = createContext()

const ThemeProvider = ({ location, scrollSmoother, children }) => {
  const [siteTheme, setSiteTheme] = useState('')
  const [showSplash, setShowSplash] = useState(true)

  const setTheme = useCallback((name) => {
    setSiteTheme(name)
  }, [])

  useEffect(() => {
    if (showSplash && !/^\/(|[a-z]{2})\/?$/.test(location.pathname)) {
      setShowSplash(false)
    }
  }, [location, showSplash, setShowSplash])

  return (
    <ThemeContext.Provider
      value={{
        siteTheme,
        setTheme,
        showSplash,
        setShowSplash,
        scrollSmoother
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
